import { render, staticRenderFns } from "./clinistatakvim.vue?vue&type=template&id=0a276ed5&scoped=true&"
import script from "./clinistatakvim.vue?vue&type=script&lang=js&"
export * from "./clinistatakvim.vue?vue&type=script&lang=js&"
import style0 from "./clinistatakvim.vue?vue&type=style&index=0&id=0a276ed5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a276ed5",
  null
  
)

export default component.exports